import api from './api-service'
import i18n from '../i18n'

export default {
    retrieveReceivables() {
        return api.retrieve('/receivables.json',  i18n.t('responses.payables'));
    },

    retrieveOrderHistory() {
        return api.retrieve('/orders.json',  i18n.t('responses.orders'));
    },

    retrieveUser() {
        return api.retrieve('/user.json',  i18n.t('responses.user'))
    },

    sendComment(subject, browser, comment, email) {
        api.send('/comment.json', 'het contactformulier', {
            subject: subject,
            browser: browser,
            comment: comment,
            email: email
        })
    }
}